import { Box } from "@mui/system";
import ImportedObjectsTable from "./ImportedObjectsTable";
import { Button, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

const tableHeadings = {
  object_level: "Object Level",
  field_name: "Field Name",
  field_value: "Field Value",
  remove_object: "Remove Object",
};
const rows = [
  {
    object_level: "Brand",
    field_name: "login_username_widget",
    field_value: "CLASS_NAME|styledCommon__StyledInput-sc-1rld9c-1.hRfOpK",
    remove_object: "",
  },
  {
    object_level: "raw_data_10131",
    field_name: "ignored_field_on_compare",
    field_value: "totalcpacommission",
    remove_object: "",
  },
  {
    object_level: "raw_data_10133",
    field_name: "cpacommissioncount",
    field_value: "totalcpacommission",
    remove_object: "",
  },
];

const ImportedObjects = () => {
  
  return (
    <>
      <Box px={2} pb={1} pt={1}>
        <Typography variant="h3" sx={{ fontSize: "24px", fontWeight: 500 }}>
          Imported Objects
        </Typography>
        <Typography variant="body2" sx={{ fontSize: "14px", mt: 0.5 }}>
          Add, edit and remove objects set to the fetcher for this brand.
        </Typography>
      </Box>
      <ImportedObjectsTable tableHeadings={tableHeadings} rows={rows} />
      <Button
        variant="text"
        startIcon={<AddIcon />}
        sx={{
          color: "#0000008F",
          fontWeight: 500,
          fontSize: 13,
          height: 36,
          px: 1.4,
          whiteSpace: "nowrap",
          m: 1,
          textTransform: "Uppercase",
          "&:hover": {
            color: "#9C27B0",
            backgroundColor: "#faf0fc",
          },
        }}
      >
        add Object
      </Button>
    </>
  );
};

export default ImportedObjects;
